<template>

  <button type="button" class="btn btn-sm btn-outline-info" data-bs-toggle="modal"
          :data-bs-target="'#modalHistory_'+model" @click="openModal">
    <i class="bi bi-clock-history"></i>&nbsp; Historia zmian
  </button>

  <!-- Modal -->
  <div class="modal fade" :id="'modalHistory_'+model" tabindex="-1" role="dialog" @click.self="closeModal"
       aria-labelledby="modelTitleId" aria-hidden="true" ref="modalHistory">
    <div class="modal-dialog modal-full-width" role="document">
      <div class="modal-content" :ref="'modalContent_'+model">
        <div class="modal-header">
          <h5 class="modal-title">Ostatnie zmiany</h5>
          <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close" @click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body table-responsive text-start">
          <ejs-grid gridLines="Both" height='100%' ref="grid"
                    :allowTextWrap='false'
                    :dataSource="histories"
                    :allowPaging="false"
                    :allowSorting='false'
                    :allowFiltering='false'
                    :allowReordering='true'
                    :allowResizing='true'
                    :showColumnChooser='true'
                    :allowSelection='true'
                    :enablePersistence='false'
          >
            <e-columns>
              <e-column field='lp' headerText='Lp.' width="70" type="numeric"></e-column>
              <e-column field='project_id' headerText='ID' width="95" type="numeric"></e-column>
              <e-column field='hide_on_list' headerText='Ukryte na liście' width="95" type="numeric"></e-column>
              <e-column field="glowice" headerText="Głowice" width="95" type="string"></e-column>
              <e-column field="archived" headerText="Zarchiwizowane" type="string"></e-column>
              <e-column field="priority" headerText="Priorytet" type="string"></e-column>
              <e-column field="status" headerText="Status" type="string"></e-column>
              <e-column field="name" headerText="Nazwa" type="string"></e-column>
              <e-column field="number" headerText="Numer" type="string"></e-column>
              <e-column field="description" headerText="Opis" type="string"></e-column>
              <e-column field="offer" headerText="Oferta" type="string"></e-column>
              <e-column field="customer" headerText="Klient" type="string"></e-column>
              <e-column field="end_of_warranty" headerText="Koniec Gwarancji" type="string"></e-column>
              <e-column field="delivery_street" headerText="Ulica Dostawy" type="string"></e-column>
              <e-column field="delivery_zip_code" headerText="Kod Pocztowy Dostawy" type="string"></e-column>
              <e-column field="delivery_city" headerText="Miasto Dostawy" type="string"></e-column>
              <e-column field="delivery_apartment" headerText="Numer Lokalu Dostawy" type="string"></e-column>
              <e-column field="series" headerText="Seria" type="string"></e-column>
              <e-column field="type" headerText="Typ" type="string"></e-column>
              <e-column field="fat" headerText="FAT" type="string"></e-column>
              <e-column field="order_opening_date" headerText="Data Otwarcia Zamówienia" type="date"
                        format="dd.MM.yyyy"></e-column>
              <e-column field="start_working_date" headerText="Data Rozpoczęcia Pracy" type="date"
                        format="dd.MM.yyyy"></e-column>
              <e-column field="planned_completion_date" headerText="Planowana Data Zakończenia" type="date"
                        format="dd.MM.yyyy"></e-column>
              <e-column field="deadline_for_completion" headerText="Termin Realizacji" type="date"
                        format="dd.MM.yyyy"></e-column>
              <e-column field="conditional_acceptance" headerText="Odbiór Warunkowy" type="string"></e-column>
              <e-column field="sales_representative" headerText="Przedstawiciel Handlowy" type="string"></e-column>
              <e-column field="project_manager" headerText="Kierownik Projektu" type="string"></e-column>
              <e-column field="engineer" headerText="Inżynier" type="string"></e-column>
              <e-column field="programmer" headerText="Programista" type="string"></e-column>
              <e-column field="electrician" headerText="Elektryk" type="string"></e-column>
              <e-column field="assembly_leader" headerText="Lider Montażu" type="string"></e-column>
              <e-column field="planning_manager" headerText="Kierownik Planowania" type="string"></e-column>
              <e-column field="engineering_manager" headerText="Kierownik Inżynierii" type="string"></e-column>
              <e-column field="automation_manager" headerText="Kierownik Automatyki" type="string"></e-column>
              <e-column field="documentation_manager" headerText="Kierownik Dokumentacji" type="string"></e-column>
              <e-column field="project_additional_arrangements_emails" headerText="Dodatkowe Ustalenia Projektu (Email)"
                        type="string"></e-column>
              <e-column field="comments" headerText="Komentarze" type="string"></e-column>
              <e-column field="bg_color" headerText="Kolor Tła" type="string"></e-column>
              <e-column field="color" headerText="Kolor" type="string"></e-column>
              <e-column field="created_at" headerText="Data Utworzenia" type="date"
                        format="dd.MM.yyyy hh:mm:ss"></e-column>
              <e-column field="created_by.email" headerText="Utworzone Przez" type="string"></e-column>
              <e-column field="deleted_by" headerText="Usunięte Przez" type="string"></e-column>
              <e-column field="deleted_at" headerText="Data usunięcia" format="dd.MM.yyyy hh:mm:ss"></e-column>
            </e-columns>
          </ejs-grid>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModal">Zamknij</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import route from "../../../../../vendor/tightenco/ziggy/src/js/index.js";

import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  Filter,
  GridComponent,
  Page,
  Reorder,
  Resize,
  Sort,
} from '@syncfusion/ej2-vue-grids';
import {ref} from "vue";

export default {
  components: {
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective
  },
  props: {
    project: Object,
    model: String
  },

  setup() {
    let isModalOpen = ref(false);

    const openModal = () => {
      isModalOpen.value = true;
    }

    return {isModalOpen}
  },

  data() {
    return {
      isLoading: false,
      histories: [],
      previousRowData: null,
    };
  },

  provide: {
    grid: [Page, Sort, Filter, Reorder, Resize, ColumnChooser]
  },

  watch: {
    isModalOpen(newValue) {
      if (newValue === true) {
        this.getHistoryForProjects()
      }
    }
  },

  methods: {

    getHistoryForProjects() {
      const self = this;
      self.isLoading = true;

      let url = Object.keys(this.project).length === 0
          ? route('projects.get-history')
          : route('projects.get-history-for-project', {'project': this.project, 'model': this.model})

      axios.post(url, {
        project: this.project,
        stringModel: this.model,
      }).then((response) => {
        self.histories = response.data;
      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.isLoading = false;
      });
    },

    openModal() {
      this.isModalOpen = true;
    },

    closeModal(model) {
      this.isModalOpen = false;
      this.histories = [];
      // Usunięcie nasłuchiwania zdarzenia hidden.bs.modal
      let refModal = 'modalHistory_' + model;
      $(this.$refs[refModal]).off("hidden.bs.modal", () => this.closeModal(model));
    },
  },
};
</script>

<style>
.different-cell {
  color: orangered !important;
  border: 1px solid orangered !important;
}
</style>
